export default (ACCESS_TOKEN_KEY) => {
    const service = {}
    const { localStorage } = window

    service.setAccessToken = (accessToken) => {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
    }

    service.deleteAccessToken = () => {
        localStorage.removeItem(ACCESS_TOKEN_KEY)
    }

    service.getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY)

    return service
}
